"use strict";

import React from 'react';
export default /*#__PURE__*/React.createContext(false);
//# sourceMappingURL=GestureHandlerRootViewContext.js.map